import React, { useState, useEffect } from 'react';
import { ArrowBigLeft, ArrowBigRight } from 'lucide-react';
import { FADE_INTERVAL_MS } from '../constants';

export const GetFrontalClass = (completed, choose) => {
  let elementClasses = "";
  if (completed) {
    elementClasses += " style-order-list-complete";
  } else if (!choose) {
    elementClasses += " style-order-list-disabled";
  }
  return elementClasses;
};

const FadingArrow = (props) => {
  const [fadeProp, setFadeProp] = useState({ fade: 'fade-in' });
  useEffect(() => {
    const fadeTimeout = setInterval(() => {
      fadeProp.fade === 'fade-in' ? setFadeProp({ fade: 'fade-out' }) : setFadeProp({ fade: 'fade-in' });
    }, FADE_INTERVAL_MS);
    return () => clearInterval(fadeTimeout);
  }, [fadeProp]);
  return (
    <span className={fadeProp.fade}>
      {props.direction === 'left' ? <ArrowBigLeft /> : <ArrowBigRight />}
    </span>
  );
};

export default FadingArrow;
